type Props = {
  type: string
  labelId: string
  label: string
  state: string
  setState: any
}

const LabelText = (props: Props) => {
  const { type, labelId, label, state, setState } = props

  return (
    <div>
      <label htmlFor={labelId}>{label}</label>
      <input
        type={type}
        id={labelId}
        value={state}
        onChange={(e) => setState(e.target.value)}
      />
    </div>
  )
}

export default LabelText
